import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PluginParameter,TransformParameter } from '../../../api/models';

@Component({
    selector: 'app-parameter',
    templateUrl: './parameter.component.html',
    styleUrls: ['./parameter.component.css']
})
export class ParameterComponent implements OnInit {
    @Input()
    parameter: PluginParameter;
    @Input()
    configItem: TransformParameter;
    
    @Input()
    enabled: boolean = true;

    @Input()
    size: string = "md";

    constructor() {}

    ngOnInit() {
    }

    changeBoolean(newValue: string) {
        console.log(this.configItem);
        this.configItem.value = newValue;
        //alert(newValue);
    }

    timeChange() {

    }
        
}
